import { RouteLocationNormalized } from 'vue-router';
import { RouteSearchResults } from "./fragments/RouteSearchResults";
import { SortingOptions } from "@/sorting/SortingOptions";
import { IEmbeddedState } from "@/url/IEmbeddedState";
import { RouteParams } from "./RouteParams";
import { NavigationTargetResult } from "./NavigationTargetResult";
import { IFragmentDetails } from "./IFragmentDetails";
import { IEmbeddedStateMutable } from "@/url/IEmbeddedStateMutable";
import { valueOrFirstOrNull } from "@/platform/arrayExtensions";
import { SortingState } from "@/sorting/SortingState";

export abstract class RouteSort extends RouteSearchResults {

	protected readonly sortRouteParam = RouteParams.SORT;
	protected readonly sortingOption: SortingOptions;
	protected readonly fragmentDetails: IFragmentDetails;
	private readonly path: string;

	public constructor(
		name: string,
		sortingOption: SortingOptions,
		fragmentDetails: IFragmentDetails,
		path: string
	) {
		super(name);
		this.sortingOption = sortingOption;
		this.fragmentDetails = fragmentDetails;
		this.path = path;
	}

	protected override selfRoutePath(): string {
		return this.fragmentDetails.getPathPattern();
	}

	protected override async selfEncodeToNavigationTarget(
		navigationTargetResult: NavigationTargetResult
	): Promise<NavigationTargetResult> {

		navigationTargetResult.navigationTarget.params ??= {};
		navigationTargetResult.navigationTarget.params[this.sortRouteParam] = this.path;
		
		return Promise.resolve(navigationTargetResult);
	}

	protected override async selfDecodeByPopulatingFrom(
		embeddedState: IEmbeddedStateMutable,
		destination: RouteLocationNormalized
	): Promise<void> {
		const sort = valueOrFirstOrNull(destination.params[this.sortRouteParam]);
		if (sort !== null) {
			embeddedState.withSortingOption(new SortingState(this.sortingOption));
		}

		return Promise.resolve();
	}

	protected override async selfSupports(embeddedState: IEmbeddedState): Promise<boolean> {
		const sortedBy = embeddedState.sortingState.isSelected(this.sortingOption);

		return Promise.resolve(sortedBy);
	}
}
